import styled from 'styled-components';
import { DividerStyle } from './Divider.styles.js';

const defaultProps = {
    decorative: false,
};
const Divider = styled.hr.attrs(({ decorative = defaultProps.decorative, ...rest }) => ({
    role: decorative
        ? 'presentation'
        : undefined /* By default <hr> has an implicit separator role */,
    ...rest,
})) `
    ${DividerStyle}
`;

export { Divider, defaultProps };
//# sourceMappingURL=Divider.js.map
